        document.addEventListener('DOMContentLoaded', function() {
            // Position the markers
            const markers = document.querySelectorAll('.feature-marker');
            markers.forEach(marker => {
                const x = marker.getAttribute('data-x');
                const y = marker.getAttribute('data-y');
                marker.style.left = `${x}%`;
                marker.style.top = `${y}%`;
            });

            // Find the scoped container (closest .grid ancestor) for an element
            function getScope(element) {
                return element.closest('.grid');
            }

            // Add hover interactions (scoped to container)
            function handleHover(element, isEntering) {
                const scope = getScope(element);
                if (!scope) return;

                const featureId = element.getAttribute('data-feature-id');
                const marker = scope.querySelector(`.feature-marker[data-feature-id="${featureId}"]`);
                const featureItem = scope.querySelector(`.feature-item[data-feature-id="${featureId}"]`);

                if (isEntering) {
                    if (marker) marker.classList.add('highlight');
                    if (featureItem) featureItem.classList.add('highlight');
                } else {
                    if (marker) marker.classList.remove('highlight');
                    if (featureItem) featureItem.classList.remove('highlight');
                }
            }

            // Add event listeners to markers
            markers.forEach(marker => {
                marker.addEventListener('mouseenter', () => handleHover(marker, true));
                marker.addEventListener('mouseleave', () => handleHover(marker, false));
            });

            // Add event listeners to feature items
            const featureItems = document.querySelectorAll('.feature-item');
            featureItems.forEach(item => {
                item.addEventListener('mouseenter', () => handleHover(item, true));
                item.addEventListener('mouseleave', () => handleHover(item, false));
            });
        });